// src/firebase.js
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBotToEjoteXqsXWPiR_8REWWKQrNreV1M",
  authDomain: "ai724-4df5b.firebaseapp.com", // //"localhost", window.location.hostname , window.location.hostname+":3000", // "ai724-4df5b.firebaseapp.com", 87.106.83.223
  projectId: "ai724-4df5b",
  storageBucket: "ai724-4df5b.firebasestorage.app",
  messagingSenderId: "45524581163",
  appId: "1:45524581163:web:ef7314072b385f7dcde36e",
  measurementId: "G-Z6FLBVH07X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
const analytics = getAnalytics(app);


// https://firebase.google.com/docs/auth/web/redirect-best-practices	Best practices for using signInWithRedirect on browsers that block third-party storage access